import React, { useState, useEffect, useRef } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Button } from '@swift-paypal/pp-react';
import OtpInput from './otp-input';
import { Alert, AlertTypes } from '../common/alert';
import './otp.less';

export const OtpForm = (props) => {
  const {
    handleSubmit, otpError, loading, verifyLoading, resendLoading, onResend, rateLimited, successMessage, change,
  } = props;
  const [otpComplete, setOtpComplete] = useState(false);
  const [errorKey, setErrorKey] = useState(0);
  const prevError = useRef(otpError);

  useEffect(() => {
    if (otpError && otpError !== prevError.current && !rateLimited) {
      setErrorKey((k) => k + 1);
      setOtpComplete(false);
    }
    prevError.current = otpError;
  }, [otpError, rateLimited]);

  const handleOtpChange = (value) => {
    change('otp', value);
    setOtpComplete(value.length === 6);
  };

  const isDisabled = loading || !otpComplete;

  const onSubmit = (e) => {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    handleSubmit(e);
  };

  return (
    <form onSubmit={onSubmit}>
      {otpError && !rateLimited && (
        <div className="margin-bottom-sm">
          <Alert message={otpError} alertType={AlertTypes.critical} />
        </div>
      )}
      {successMessage && (
        <div className="margin-bottom-sm">
          <Alert message={successMessage} alertType={AlertTypes.success} />
        </div>
      )}
      {rateLimited && otpError && (
        <div className="margin-bottom-sm">
          <Alert message={otpError} alertType={AlertTypes.warning} />
        </div>
      )}
      <div>
        <label
          htmlFor="otp-input-0"
          className="otp-label"
        >
          Verification Code
        </label>
        <OtpInput onChange={handleOtpChange} disabled={loading} errorKey={errorKey} />
      </div>
      <div
        className="otp-submit-wrapper"
        style={{
          opacity: isDisabled ? 0.5 : 1,
          pointerEvents: isDisabled ? 'none' : 'auto',
        }}
      >
        <Button
          type="submit"
          className="pp-react__button--block"
        >
          {verifyLoading ? 'Verifying...' : 'Verify'}
        </Button>
      </div>
      <div>
        <span>
          Didn&apos;t receive a code?
          {' '}
          <a
            href="#resend"
            style={{
              pointerEvents: loading ? 'none' : 'auto',
              opacity: loading ? 0.5 : 1,
            }}
            onClick={(e) => {
              e.preventDefault();
              if (!loading) onResend();
            }}
          >
            {resendLoading ? 'Resending...' : 'Resend OTP'}
          </a>
        </span>
      </div>
    </form>
  );
};

OtpForm.propTypes = {
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  verifyLoading: PropTypes.bool,
  resendLoading: PropTypes.bool,
  onResend: PropTypes.func.isRequired,
  otpError: PropTypes.string,
  rateLimited: PropTypes.bool,
  successMessage: PropTypes.string,
};

OtpForm.defaultProps = {
  loading: false,
  verifyLoading: false,
  resendLoading: false,
  otpError: undefined,
  rateLimited: false,
  successMessage: undefined,
};

const OtpFormComponent = reduxForm({
  form: 'otp',
})(OtpForm);

export default OtpFormComponent;
